import React, { useState } from "react";
import { lang } from "../../lang";
import AddFlashCardForm from "./AddFlashCardForm"; // For adding cards under selected topic
import "./TopicList.css";

function TopicList({
  topics,
  selectedTopicId,
  onSelectTopic,
  onAddTopic,
  onDeleteTopic,
  onUpdateTopicName,
  // Props needed for AddFlashCardForm, passed down from FlashCardsPage
  topicCategories,
  onAddCard,
}) {
  const [newTopicName, setNewTopicName] = useState("");
  const [editingTopicId, setEditingTopicId] = useState(null);
  const [editingTopicName, setEditingTopicName] = useState("");

  const handleAddTopic = () => {
    if (newTopicName.trim()) {
      onAddTopic(newTopicName.trim());
      setNewTopicName("");
    }
  };

  const handleNewTopicKeyDown = (e) => {
    if (e.key === "Enter") {
      handleAddTopic();
    }
  };

  const handleEditTopic = (topic) => {
    setEditingTopicId(topic.id);
    setEditingTopicName(topic.name);
  };

  const handleSaveTopicName = (topicId) => {
    if (editingTopicName.trim() && typeof onUpdateTopicName === "function") {
      onUpdateTopicName(topicId, editingTopicName.trim());
    }
    setEditingTopicId(null);
    setEditingTopicName("");
  };

  const handleEditKeyDown = (e, topicId) => {
    if (e.key === "Enter") {
      handleSaveTopicName(topicId);
    } else if (e.key === "Escape") {
      setEditingTopicId(null);
      setEditingTopicName("");
    }
  };

  return (
    <div className="topic-list-container">
      <div className="add-topic-section">
        <input
          type="text"
          className="add-topic-input"
          placeholder={
            lang.flashCards.topicNamePlaceholder || "New Topic Name..."
          }
          value={newTopicName}
          onChange={(e) => setNewTopicName(e.target.value)}
          onKeyDown={handleNewTopicKeyDown}
        />
        <button className="add-topic-button" onClick={handleAddTopic}>
          {lang.flashCards.addTopic || "Add Topic"}
        </button>
      </div>
      <ul className="topic-list">
        {topics.map((topic) => (
          <li
            key={topic.id}
            className={`topic-list-item-wrapper ${
              selectedTopicId === topic.id ? "selected-topic-wrapper" : ""
            }`}
          >
            <div
              className={`topic-list-item ${
                selectedTopicId === topic.id ? "selected" : ""
              }`}
              onClick={() => onSelectTopic(topic.id)}
            >
              {editingTopicId === topic.id ? (
                <input
                  type="text"
                  value={editingTopicName}
                  onChange={(e) => setEditingTopicName(e.target.value)}
                  onBlur={() => handleSaveTopicName(topic.id)}
                  onKeyDown={(e) => handleEditKeyDown(e, topic.id)}
                  className="edit-topic-input"
                  autoFocus
                  onClick={(e) => e.stopPropagation()} // Prevent topic selection while editing name
                />
              ) : (
                <span className="topic-name">{topic.name}</span>
              )}
              <div className="topic-actions">
                <button
                  className="topic-action-button edit-topic-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditTopic(topic);
                  }}
                  title="Edit topic name"
                >
                  &#9998; {/* Pencil icon */}
                </button>
                <button
                  className="topic-action-button delete-topic-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteTopic(topic.id);
                  }}
                  title="Delete topic"
                >
                  &times; {/* Cross icon */}
                </button>
              </div>
            </div>
            {/* Render AddFlashCardForm if this topic is selected */}
            {selectedTopicId === topic.id && (
              <div className="add-card-form-for-topic">
                <AddFlashCardForm
                  topicId={selectedTopicId}
                  topicCategories={topicCategories} // These are categories for the *selected* topic
                  onAddCard={onAddCard}
                />
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TopicList;
